define((require) => {
    "use strict";

    const ReactBridge = require("backbone.react-bridge");
    var _ = require("underscore"),
        Marionette = require("marionette"),
        Configuration = require("shared/services/Configuration"),
        DefaultFooterView = require("editor/ui/common/DefaultFooterView");
    const AnalyticsPropertiesView = require("ui/experience/widgets/analytics/AnalyticsPropertiesView").default;
    const OnLoadAction = require("ui/experience/action/OnLoadAction").default;
    const BehaviorSettings = require("ui/experience/action/behavior/BehaviorSettings").default;
    /**
     * Improved Marionette Layout/ItemView with some extra options.
     *
     * @author Bo Gotthardt
     * @class ImprovedView
     */
    return Marionette.Layout.extend({

        _subModelEvents: null,

        constructor: function() {
            // Inject configuration into template helpers...
            if (_.isFunction(this.templateHelpers)) {
                var _templateHelpers = this.templateHelpers.bind(this);
                this.templateHelpers = function() {
                    var helpers = _templateHelpers();
                    helpers.config = Configuration; // TODO: we should  also inject Permissions

                    return helpers;
                };

                // May be an object, or not set at all...
            } else {
                if (!this.templateHelpers) {
                    this.templateHelpers = {};
                }

                this.templateHelpers.config = Configuration; // TODO: ditto
            }

            this.listenTo(this, "item:rendered", function() {
                // Add support for the default footer view
                if (this.defaultFooterRegion) {
                    this.defaultFooterRegion.show(new DefaultFooterView());
                }
            });

            // Setup any "sub model events"
            this._setupSubModelEvents();

            // Invoke super constructor
            this.__super();
        },

        append: function(child, container) {
            container = container || this.$el;

            if (_.isFunction(child.render)) {
                child = child.render().$el;
            }

            container.append(child);
        },

        _setupSubModelEvents: function() {
            this._subModelEvents = [];

            _.each(Marionette.getOption(this, "modelEvents"), function(method, eventName) {
                var i = eventName.indexOf(".");

                if (i > -1) {
                    var subModelPropertyName = eventName.substring(0, i),
                        subModelEventName = eventName.substring(i + 1, eventName.length),
                        bindings = {};

                    bindings[subModelEventName] = method;

                    this._subModelEvents.push({
                        subModelPropertyName: subModelPropertyName,
                        subModelEventName: subModelEventName,
                        bindings: bindings
                    });
                }
            }, this);
        },

        /**
         * Add Analytics label
         */
        _setAnalyticsLabel({model: widgetModel}) {
            const emailModeChangeWidgetEvent = "emailModeChange";
            const experienceModel = this.viewScope.viewModel.get("experience");
            this.listenTo(experienceModel, "change:emailModeEnabled", () => {
                widgetModel.trigger(emailModeChangeWidgetEvent);
            });
            const getScopedProps = ({model, experience}) => {
                const currentAnalytics = model.get("analytics") || {};
                const emailModeEnabled = experience.get("emailModeEnabled");
                return {
                    onChange: (value) => {
                        const analytics = {label: value};
                        model.set("analytics", analytics);
                    },
                    labelValue: currentAnalytics.label,
                    emailModeEnabled: emailModeEnabled
                };
            };

            return ReactBridge.viewFromComponent(AnalyticsPropertiesView, {
                model: widgetModel,
                experience: experienceModel,
                observe: {
                    model: ["change", emailModeChangeWidgetEvent]
                },
                getProps: getScopedProps
            });
        },

        _setBehaviorAction({model: widgetModel}) {
            const experienceModel = this.viewScope.viewModel.get("experience");
            const getScopedProps = () => {
                const {mapWidgetMetaData}              = require("ui/editor/SceneEditorHelpers");
                return {
                    getExperience: () => {
                        return experienceModel.toJSON();
                    },
                    notifyParent: (expJson, state) => {
                        experienceModel.set("behaviors", expJson.behaviors);
                        experienceModel.set("behaviorConfig", expJson.behaviorConfig);
                        if (state === "saved") { experienceModel.trigger("behaviorSaved"); }
                    },
                    getBaseUrl: () => {
                        return process.env.APP_CONFIG.behaviorUiBaseUrl;
                    }
                };
            };
            return ReactBridge.viewFromComponent(BehaviorSettings, {
                model: widgetModel,
                experience: experienceModel,
                getProps: getScopedProps
            });
        },

        _setOnLoadAction({model: widgetModel}) {
            const emailModeChangeWidgetEvent = "emailModeChange";
            const experienceModel = this.viewScope.viewModel.get("experience");
            this.listenTo(experienceModel, "change:emailModeEnabled", () => {
                widgetModel.trigger(emailModeChangeWidgetEvent);
            });
            const getScopedProps = ({model}) => {
                const currentOnLoadJs = model.get("onloadJs") || {};
                let name = currentOnLoadJs.name ? currentOnLoadJs.name : "";
                let parameters = currentOnLoadJs.parameters ? currentOnLoadJs.parameters : {};
                let params = !(_.isEmpty(parameters)) ? Object.keys(parameters).map((el) => ({paramLabel: el, paramValue: parameters[el]})) : [];
                return {
                    onChange: (value) => {
                        // Holds all the paramLabel and their respective value that are used to keep the state in sync with the props
                        let params = [];

                        if (value.label === "None") {
                            model.set("onloadJs", null);
                            value.model = null;
                        }

                        if (value.model) {
                            const attr = value.model,
                                onloadJs = {
                                    type: attr.type,
                                    code: attr.code,
                                    actionId: attr.actionId,
                                    name: value.label,
                                    parameters: attr.parameters
                                };
                            model.set("onloadJs", onloadJs);

                            // If the parameters are not empty than transform it to params[] i.e. {key: paramLabel, key: paramValue}
                            if (!(_.isEmpty(onloadJs.parameters))) {
                                params = Object.keys(onloadJs.parameters)
                                    .map((el) => ({paramLabel: el, paramValue: onloadJs.parameters[el]}));
                            }
                        }
                        return params;
                    },
                    name,
                    parameters,
                    params
                };
            };

            return ReactBridge.viewFromComponent(OnLoadAction, {
                model: widgetModel,
                experience: experienceModel,
                observe: {model: ["change", emailModeChangeWidgetEvent]},
                getProps: getScopedProps
            });
        },

        delegateEvents: function() {
            Marionette.Layout.prototype.delegateEvents.apply(this, _.toArray(arguments));

            _.each(this._subModelEvents, function(descriptor) {
                Marionette.bindEntityEvents(this, this.model[descriptor.subModelPropertyName], descriptor.bindings);
            }, this);
        },

        undelegateEvents: function() {
            Marionette.Layout.prototype.undelegateEvents.apply(this, _.toArray(arguments));

            _.each(this._subModelEvents, function(descriptor) {
                Marionette.unbindEntityEvents(this, this.model[descriptor.subModelPropertyName], descriptor.bindings);
            }, this);
        },

        toString: function() {
            return "ImprovedView[cid: " + this.cid + "]";
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/zbone/ImprovedView.js